import Vue from 'vue'
import Router from 'vue-router'
import Playlist from './views/Playlist.vue'
// import Users from './views/Users.vue'

Vue.use(Router)

export default new Router({
//   mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
		path: '/',
		name: 'Playlist',
		component: Playlist
	},
	{
		path: '/users',
		name: 'Users',
		component: () => import('./views/Users.vue')
	},
    {
		path: '/mon',
		name: 'Monitoring',
		component: () => import('./views/Monitoring.vue')
	},
	{
		path: '/stats',
		name: 'Stats',
		component: () => import('./views/Stats.vue')
	},
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
